import React from 'react';

import {
  type AdServer,
  type LayoutType,
  type PlacementId
} from '@schibsted-nmp/advertising-shared';

import { Intermingle } from './useIntermingles.js';

export type PositionData = {
  position: number;
  placementId: PlacementId;
  containerId: string;
  adServer: AdServer;
};

export function useSearchPositionInstruction(
  layoutType: LayoutType
): ReadonlyArray<PositionData> {
  const interminglePlacements = Intermingle.List.use();

  return React.useMemo(
    () =>
      interminglePlacements
        .map<PositionData | null>(({ placementId, intermingle, adServer }) => {
          const interval = intermingle?.[layoutType];
          if (!interval) return null;

          return {
            containerId: `${placementId}--container`,
            placementId,
            position: interval,
            adServer: adServer.type as AdServer
          };
        })
        .filter((positionData) => positionData !== null),
    [layoutType, interminglePlacements]
  );
}
